export default __webpack_public_path__ + "677230f0fe2cae9394d857f09472d478.png";